import { useEffect, useMemo } from 'react';
import { useUsersEmailsLazyQuery } from 'src/graphql/_generated';

const useIsRealUser = (params: { workspaceId?: string; orgId?: string }) => {
  const { workspaceId, orgId } = params;
  const [getUsersEmails, { data }] = useUsersEmailsLazyQuery();

  useEffect(() => {
    if (workspaceId || orgId) {
      getUsersEmails({ variables: { workspaceId, orgId } });
    }
  }, [workspaceId, orgId, getUsersEmails]);

  // Create Map for email-to-id mapping from both workspace and organisation users
  const emailToIdMap = useMemo(() => {
    const workspaceUsers = data?.workspace?.users || [];
    const orgUsers = data?.organisation?.users || [];
    const emailIdMap = new Map<string, string>();

    // Add workspace users
    workspaceUsers.forEach((user) => {
      if (user.email && user.id) {
        emailIdMap.set(user.email, user.id);
      }
    });

    // Add organisation users (won't overwrite if already present)
    orgUsers.forEach((user) => {
      if (user.email && user.id && !emailIdMap.has(user.email)) {
        emailIdMap.set(user.email, user.id);
      }
    });

    return emailIdMap;
  }, [data]);

  const _getRealUserId = useMemo(() => {
    return (email?: string | null): string | null => {
      if (!email) return null;
      return emailToIdMap.get(email) || null;
    };
  }, [emailToIdMap]);

  return { getRealUserId: _getRealUserId };
};

export default useIsRealUser;
